var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerProcessed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "29px",
    viewBox: "0 0 23 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A0766276-4DCB-45A4-A8FC-BDA1485E6172") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task-overview---Plan",
    transform: "translate(-1330.000000, -502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map",
    transform: "translate(890.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconPointer/Current",
    transform: "translate(440.000000, 391.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,0.5 C14.5375661,0.5 17.2875661,1.73121694 19.2781746,3.72182541 C21.2687831,5.71243388 22.5,8.46243388 22.5,11.5 C22.5,15.5950659 18.7799241,21.1838995 11.4987144,28.3009118 C4.21961463,21.1832065 0.5,15.594812 0.5,11.5 C0.5,8.46243388 1.73121694,5.71243388 3.72182541,3.72182541 C5.71243388,1.73121694 8.46243388,0.5 11.5,0.5 Z",
    id: "Oval",
    stroke: "#C4A302",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    cx: 11.5,
    cy: 10.5,
    r: 2.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerProcessed);
export default __webpack_public_path__ + "static/media/MapMarkerProcessed.37768cb80af68e44734c80cc4957dca4.svg";
export { ForwardRef as ReactComponent };